import { StubPage } from '../StubPage'
export function Subscriptions() {
  return <StubPage title="Subscriptions" summary="Subscriptions register a callback URL and event-type filter. When a matching event is published, BUZZ sends an HTTP POST to the callback with the event payload. Subscriptions support wildcard type matching." />
}
